export const SHOW_DIALOG_BOX = '@komigen/mobile-frontend/support/SHOW_DIALOG_BOX';

export const TOGGLE_SUPPORT_LOADING_STATUS = '@komigen/mobile-frontend/support/TOGGLE_SUPPORT_LOADING_STATUS';

export const SUPPORT_VIP_TAG_CV_VALUE = '@komigen/mobile-frontend/support/SUPPORT_VIP_TAG_CV_VALUE';

export const SUPPORT_ADA_UPDATE_CUSTOM_METAFIELD =
	'@komigen/mobile-frontend/support/SUPPORT_ADA_UPDATE_CUSTOM_METAFIELD';

export const SUPPORT_ADA_REMOVE_CUSTOM_METAFIELD =
	'@komigen/mobile-frontend/support/SUPPORT_ADA_REMOVE_CUSTOM_METAFIELD';
